import Image from 'next/image';
import useUserVerificationGuideViewModel from '../hooks/useUserVerificationGuideViewModel';

const UserVerificationGuideView = () => {
  const { handleCertification } = useUserVerificationGuideViewModel();

  return (
    <div className='relative flex min-h-screen w-full flex-col bg-white'>
      <div className='box-border flex flex-col gap-[8px] px-[24px] pt-[12px] pb-0'>
        <h1 className='typography-ui-24sb text-gray-900'>
          마지막으로 안전한 진료를 위해
          <br />
          본인인증이 필요해요
        </h1>
        <p className='typography-ui-17r text-gray-600'>6개월마다 본인 명의 핸드폰 인증이 필요해요.</p>
      </div>

      <div className='box-border flex flex-1 flex-col items-center justify-center gap-[24px] px-[24px] pt-[40px] pb-[90px]'>
        <div className='relative h-[240px] w-[232px]'>
          <Image
            src='/images/certification/certification_guide_icon.png'
            alt='본인인증 안내'
            width={232}
            height={240}
            style={{ objectFit: 'cover' }}
            priority
          />
        </div>
      </div>

      <div className='mx-[24px] mb-[34px] box-border flex h-[56px] items-center justify-center gap-[8px] rounded-[12px] bg-primary-600 px-[20px] py-0'>
        <button onClick={handleCertification} className='w-full'>
          <p className='typography-ui-17sb text-center text-white'>본인인증</p>
        </button>
      </div>
    </div>
  );
};

export default UserVerificationGuideView;
